import { useState, useEffect } from "react";

const useLocalStorage = (key, defaultValue) => {
  let initialValue;
  try {
    const item = getLocalStorageItem(key);
    initialValue = item ? item : defaultValue;
  } catch (error) {
    console.error(error);
    initialValue = defaultValue;
  }
  const [storedValue, setStoredValue] = useState(initialValue);
  useEffect(() => {
    try {
      setLocalStorageItem(key, storedValue);
    } catch (error) {
      console.error(error);
    }
  }, [key, storedValue]);

  return [storedValue, setStoredValue];
};

export default useLocalStorage;

export function getLocalStorageItem(key) {
  const value = window.sessionStorage.getItem(key);
  try {
    return JSON.parse(value);
  } catch (error) {
    return value;
  }
}

export function setLocalStorageItem(key, value) {
  if (typeof value !== "string" && !(value instanceof String)) {
    value = JSON.stringify(value);
  }
  window.sessionStorage.setItem(key, value);
}
